import {ChildEntity} from "typeorm";
import {Player} from "@/modules/team/entity";
import {Notification} from "@/modules/notifications/entity";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import TransferOfferAbortNotificationComponent from "@/modules/transfer-market/components/TransferOfferAbortNotification.vue";

@ChildEntity()
export class TransferOfferAbortNotification extends Notification {
  setPayload(player: Player) {
    this.payloadRaw = JSON.stringify({
      playerId: player.id,
      playerName: player.shortName,
      teamId: player.team!.id,
      teamName: player.team!.name
    });

    return this;
  }

  get payload(): { playerId: number, playerName: string, teamId: number, teamName: string } {
    return JSON.parse(this.payloadRaw!);
  }

  get component(): ShallowRef<Component> {
    return shallowRef(TransferOfferAbortNotificationComponent);
  }
}